import * as React from "react";

import { useStoreState } from "../store";

export interface SetupProps {
  children?: React.ReactNode;
}

function Authorized({ children }: SetupProps) {
  const authorized = useStoreState((state) => state.auth.authorized);
  console.log("authorized = ", authorized)

  return <>{authorized && children}</>;
}

export default Authorized;
